import { Box, Button, Typography } from '@mui/material';
import he from 'he';
import sanitizeHtml from 'sanitize-html';
import createRelativeImageURL from '@/utils/createRelativeImageURL';
import { trackAmplitudeEvent } from '@/lib/analyticsHelper';

import { seoSegmentationListingPage_seoSegmentationHeroImage_SEOSegmentationHeroImageSuccess as HeroImageSuccessType } from '@/__generated__/seoSegmentationListingPage';

interface HeroImgContent {
  enrollmentURL: string;
  headline: string;
  heroImage: HeroImageSuccessType['heroImage'];
  subHeadline: string;
}

const JobHero = ({ enrollmentURL, headline, heroImage, subHeadline }: HeroImgContent) => {
  const handleJoinFreeBtn = () => {
    const amplitudeData = {
      cta_text: 'Join free to get started',
      cta_type: 'button',
    };

    trackAmplitudeEvent('CTA Interacted', amplitudeData);
  };

  return (
    <Box
      sx={(theme) => ({
        overflow: 'hidden',
        minHeight: '250px',
        padding: `${theme.spacing(3)} 0`,
        backgroundPosition: '50% bottom',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundColor: theme.palette.care.grey[600],
        display: 'flex',
        justifyContent: 'center',
        backgroundImage: heroImage
          ? `url(${createRelativeImageURL(heroImage.smallImageURL)})`
          : 'none',

        [theme.breakpoints.up('sm')]: {
          minHeight: '300px',
          backgroundImage: heroImage
            ? `url(${createRelativeImageURL(heroImage.largeImageURL)})`
            : 'none',
        },
      })}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          minHeight: '250px',
          padding: 2,
        }}>
        <Typography
          align="center"
          variant="h1"
          color="primary"
          sx={{
            color: 'care.white',
            lineHeight: '32px',
            fontSize: '2rem',
            letterSpacing: '0.1px',
          }}>
          {headline}
        </Typography>
        <Box
          data-testid="sub-text"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(he.decode(subHeadline)),
          }}
          sx={{
            color: `care.white`,
            textAlign: 'center',
            marginBottom: 2,
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: '24px',

            '& p:first-of-type': {
              marginBottom: 0,
            },

            '& p + p': {
              margin: 0,
            },
          }}
        />

        <Button
          href={enrollmentURL}
          color="primary"
          variant="contained"
          component="a"
          className="flexible"
          onClick={handleJoinFreeBtn}
          rel="nofollow">
          Join free to get started
        </Button>
      </Box>
    </Box>
  );
};

export default JobHero;
